import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';



@Injectable({
  providedIn: 'root'
})
export class DashboardService {
live_Url: string = "https://api-insurance.bestassurance.com.gh/smartCover/api"
// live_Url: string = "https://api-insurance.bestassurance.com.gh:8085/smartCover/testapi"
// live_Url: string = "https://c1f2-196-44-99-206.ngrok-free.app/smartCover/api"


  app_env:  string = 'TEST'
  base_Url: string = null;

 


  notifyBucket: any = "/topics/com.ecl.smartcoveragent";
  notifyUrl: any = 'https://fcm.googleapis.com/fcm/send';
  MailSender_Url: any = "https://886cac0e96dc.ngrok.io/smartCover/api";

  isLoggedInStatus: any;

  private httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Access-Control-Allow-Origin', '*')
    .set("Acces-Control-Allow-Methods", "GET, POST, PATCH, PUT, DELETE, OPTIONS")
    .set("Acces-Control-Allow-Headers", "Origin, Content-Type, Cookies");



    private gethttpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/vnd.openxmlformats-ficedocument.spreadsheetml.sheet')
    
    // .set('Access-Control-Allow-Origin', '*')
    // .set("Acces-Control-Allow-Methods", "GET, POST, PATCH, PUT, DELETE, OPTIONS")
    // .set("Acces-Control-Allow-Headers", "Origin, Content-Type, Cookies");

    


  private smshttpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')

  private options = {
    headers: this.httpHeaders
  };



  private getOptions = {
    headers: this.gethttpHeaders
  };




  private smsoptions = {
    headers: this.smshttpHeaders
  };


  constructor(private http: HttpClient) {
    //this.base_Url = this.app_env == 'LIVE' ? this.test_Url : this.live_Url;
    this.base_Url = this.live_Url
  }

  get isLoggedIn() {
    this.isLoggedInStatus = localStorage.isLoggedInStatus
    if (!this.isLoggedInStatus) {
      return false
    } else {
      return true
    }
  }

    strDateToDBFormat(date :string){
       if(date){
        let dateParts=date.split("/");
        if(dateParts.length>1)
        return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
       }
       return null;

  }
    dateToDBFormat(date :Date){
    let date1= new Date(date);
    return `${date1.getFullYear()}-${(date1.getMonth()+1)}-${date1.getDate()}`;
  }

    strPadLeft(number, length) {

    var str = '' + number;
    while (str.length < length) {
        str = '0' + str;
    }

    return str;
  }

 //get all quotes here
  getquote(payload){
    return this.http.post(this.base_Url+'/v2/quotes/get_quotes',(payload));
   }

  //  Search Make
  searchMake(agent_code, search_parameter,customer_code){
    return this.http.post(this.base_Url+'/general/search_make_model',({agent_code:agent_code, make:search_parameter,client_code:customer_code,activity:"make",module:"client"}), this.options)
  }
  //  Search Model
  searchModel(agent_code,make_code ,search_parameter,customer_code){
    return this.http.post(this.base_Url+'/general/search_make_model',({agent_code:agent_code,make:"", make_code:make_code,model:search_parameter,client_code:customer_code,activity:"model",module:"client"}), this.options)
  }
  //  Search Model
  searchColor(search_parameter){
    return this.http.post(this.base_Url+'/general/retrieve_color',({color:search_parameter}), this.options)
  }

    //  Search Customer
  searchCustomer(payload:any){
    return this.http.post(this.base_Url+'/agents/search_customers', payload, this.options)

  }

    //submit Moto Quote
  submitMotoQuote(payload :any){
    return this.http.post(this.base_Url+'/general/add_quote',(payload), this.options)
  }

    //create quote
  createQuote(payload :any){
    return this.http.post(this.base_Url+'/v2/quotes/create',(payload), this.options)
  }

  //add vehicle
  addVehicle(payload :any){
      return this.http.post(this.base_Url+'/v2/quotes/update',(payload), this.options)
  }

  //add vehicle
  editVehicle(payload :any){
    return this.http.post(this.base_Url+'/v2/quotes/update',(payload), this.options)
}

  //add vehicle
  deleteVehicle(payload :any){
    return this.http.post(this.base_Url+'/v2/quotes/delete',(payload), this.options)
}

    //onChasisChange
  checkChasis(payload: any){
    return this.http.post(this.base_Url + "/general/search_chassis", payload, this.options);
  }

    //get currencies
  getCurrencies(){
    return this.http.post(this.base_Url+'/general/retrieve_currency',({}), this.options)
  }
  //get currencies
  getBodyTypes(){
    return this.http.post(this.base_Url+'/general/retrieve_body_types',({}), this.options)
  }

    //get all the schedules/risks
  getSchedulesAndRisks(){
    return this.http.post(this.base_Url+'/general/retrieve_usages',({}), this.options)
  }

 
  // login api
  getLogin(test) {
    return this.http.post(this.base_Url + '/manager_login', test, this.options);
  }

  //agent pin reset
  resetAgentPin(payload) {
    return this.http.post(this.base_Url + '/general/reset_pin', payload, this.options);
  }

  //rpa  test
  rpa(test) {
    return this.http.post(this.base_Url + '/managers/saveDBB', test, this.options);
  }
  // register agents api
  addagent(agent) {
    return this.http.post(this.base_Url + '/managers_create_agent', JSON.stringify(agent), this.options);//analytics
  }
  // show all agents api
  getAgents(data) {
    return this.http.post(this.base_Url + '/managers/get_info', data, this.options);//agents
  }
  // quotes aprove api
  quoteprove(invoice, status) {
    invoice.status = status;
    return this.http.post(this.base_Url + '/managers/approve_quote', JSON.stringify({ invoice_no: invoice.invoice_no, status: invoice.status }), this.options)
  }
  // get all quotes here
  // getquote(data) {
  //   return this.http.post(this.base_Url + '/managers/get_quotes', data, this.options);
  // }

  // all customers api
  getCustomers(data) {
    return this.http.post(this.base_Url + '/managers/get_info', data, this.options);//customers
  }

  changePassword(data) {
    return this.http.post(this.base_Url + '/managers/change_password', data, this.options);
  }

  getTransaction(data: any) {
    console.log(data)
    return this.http.post(this.base_Url + '/managers/get_transactions', data, this.options);//Transactions
  }

  //  new Customers

  newClient(email, role) {
    return this.http.post(this.base_Url + '/managers/get_newClients', ({ email: email, role: role }), this.options)
  }

  getNotifications(id) {
    return this.http.post(this.base_Url + '/agents/get_notifications', ({ id: id }), this.options)
  }

  // Send notifications
  sendNotification(data: any) {
    return this.http.post(this.notifyUrl, data, this.smsoptions)
  }

  // Send Notifications
  sendSmstoDb(data) {
    console.log(data);

    return this.http.post(this.base_Url + '/managers/add_notification', data, this.options)
  }

  // all total and daily production amount
  getAnaytics(email, role) {
    return this.http.post(this.base_Url + '/managers/get_transactions_analytics', JSON.stringify({ email: email, role: role }), this.options);//analytics
  }
  // for Cash inflow, cheque, mobile money
  Cashsegregate(email, role) {
    return this.http.post(this.base_Url + '/managers/get_transactions_total_type', ({ email: email, role: role }), this.options);
  }

  //  transaction graph
  gettransactionDetails(data) {
    return this.http.post(this.base_Url + '/managers/get_transactions_Period_Details', data, this.options)
  }

  // top performing agents
  getTopPerformingAgent(data: any) {
    return this.http.post(this.base_Url + '/managers/get_topPerformingAgents', data, this.options)
  }
  // sticker sales analytics
  getStickersalesgraph(data) {
    return this.http.post(this.base_Url + '/managers/get_stickerOverPeriod', data, this.options)
  }
  // policy sales graph
  policiesGraphapi(data) {
    return this.http.post(this.base_Url + '/managers/get_PolicyOverPeriod', data, this.options)
  }
  // claims sections
  claimProcess(data) {
    return this.http.post(this.base_Url + '/claims/get_claims', (data), this.options)
  }
  // reister managers
  addManager(mdata) {
    // console.log(mdata);
    return this.http.post(this.base_Url + '/managers/add', mdata, this.options)
  }

   // update managers
  updateManager(mdata) {
    // console.log(mdata);
    return this.http.post(this.base_Url + '/managers/update', mdata, this.options)
  }

  // get all managers
  getManagers(email: any, role) {
    return this.http.post(this.base_Url + '/get_managers', JSON.stringify({ email: email, role: role }), this.options)
  }

  // get all stickers here
  getAllstickers(data: any) {
    return this.http.post(this.base_Url + '/managers/get_stickers', data, this.options);
  }

  // get all policies listings
  getAllpolicies(data: any,) {
    return this.http.post(this.base_Url + '/managers/get_policies', data, this.options);
  }

  //request password reset
  resetPassword(payload: any) {
    return this.http.post(this.base_Url + '/managers/reset_password', payload, this.options);
  }

  //add security questions
  addSecurityQuestions(payload) {
    return this.http.post(this.base_Url + '/managers/add_security_answers', payload, this.options);
  }
  resetPasswordRequest(payload: any) {
    return this.http.post(this.base_Url + '/managers/request_password_reset', payload, this.options);
  }

  //reister brokers
  addBroker(payload) {
    return this.http.post(this.base_Url + '/brokeruser/create', payload, this.options);
  }

  //update brokers
  updateBroker(payload) {
    return this.http.post(this.base_Url + '/brokeruser/update', payload, this.options);
  }

  //disable/activate brokers
  disableBroker(payload) {
    return this.http.post(this.base_Url + '/brokeruser/disable', payload, this.options);
  }

  //get all brokers
  getBrokers(payload) {
    return this.http.post(this.base_Url + '/brokeruser/all', payload, this.options)
  }

//reset user
  resetBRokerUserPin(payload) {
    return this.http.post(this.base_Url + '/brokeruser/reset_pin_admin', payload, this.options);
  }


  //get all broker companies
  getBrokerCompanies(payload){
    return this.http.post(this.base_Url + '/agents/get_brokers', payload, this.options)
  }




  //brokeradmin 
   //reister brokers
   addBrokerAdmin(payload) {
    return this.http.post(this.base_Url + '/v2/brokeradmin/create', payload, this.options);
  }

  getBrokerMainAdmin(payload){
    return this.http.post(this.base_Url + '/v2/brokeradmin/fetch_broker_codes', payload, this.options)
  }

  
    //get all brokers admins
    getBrokerAdmins(payload) {
      return this.http.post(this.base_Url + '/v2/brokeradmin/fetch_all', payload, this.options)
    }


    //disable admin
    disableBrokerAdmin(payload) {
      return this.http.post(this.base_Url + '/v2/brokeradmin/disable', payload, this.options);
    }

    updateBrokerAdmin(payload) {
      return this.http.post(this.base_Url + '/v2/brokeradmin/update', payload, this.options);
    }
  

    resetBRokerAdminPin(payload) {
      return this.http.post(this.base_Url + '/v2/brokeradmin/reset_by_admin', payload, this.options);
    }
  

  //report to excel api 
//  exportToExcel(payload){

//     return this.http.post(this.base_Url + '/report/create',  { responseType: 'blob' as 'blob' })
//   }


  //get all branches
  getBranches() {
    return this.http.post(this.base_Url + '/general/retrieve_branches', ({}), this.options)
  }


  //get all agent 

  getAllAgents() {
    return this.http.post(this.base_Url + '/agents/all_agents', ({}), this.options)
  }


  exportToExcel(payload){


    // let queryParams = new HttpParams({ fromObject: payload }); 
   

    // console.log("queryParams"+queryParams)

  
   // return this.http.get(this.base_Url + '/report/create?'+queryParams, { responseType: 'blob' as 'blob'   })

   // return this.http.post(this.base_Url + '/report/create', payload , { responseType: 'blob' as 'blob'   })



   const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requestOptions: Object = {
      headers: headers,
      responseType: 'blob'
    }

    
    return this.http.post(this.base_Url + '/report/create', payload , {headers, responseType: 'blob' as 'blob'   } )
  }


//manual overruide 
  manualPush(mdata) {
    // console.log(mdata);
    return this.http.post(this.base_Url + '/manual_query_admin', mdata, this.options)
  }

  NICRepush(payload) {
    return this.http.post(this.base_Url + '/v2/nicmid/re-push', payload, this.options)
  }   cancelPolicy(payload:any){
    return this.http.post(this.base_Url + "/v2/policy/cancel", payload, this.options);
  }

  // Billing endpoints
  getBillingData(payload: { month: string }) {
    return this.http.get(this.base_Url + '/v2/billing-invoices/generate',
      { params: { month: payload.month }, headers: this.httpHeaders }
    );
  }

  getBillingByDateRange(startDate: string, endDate: string) {
    return this.http.get(
      this.base_Url + '/v2/billing-invoices/date-range',
      { params: { startDate, endDate }, headers: this.httpHeaders }
    );
  }

  updateBillingStatus(payload: any) {
    return this.http.post(this.base_Url + '/v2/billing/update_status', payload, this.options);
  }

  getBranchData() {
    return this.http.post(this.base_Url + '/general/get_branches', {}, this.options);
  }



   //validations
   validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
   }
   validatePhone(phone){
     if(phone && !isNaN(+`${phone.trim()}`) && phone.trim().length==10 && phone.startsWith('0'))
      return true
    else
      return false;
   }

   validateGhanaCard(cardNumber){
     if (!cardNumber) return false;
     // Ghana Card pattern: GHA-XXXXXXXXX-X or USD-XXXXXXXXX-X
     const ghanaCardRegex = /^(GHA|USD)-\d{9}-\d$/;
     return ghanaCardRegex.test(cardNumber.trim());
   }

}
